import React, { useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import apiClient from "../../api/apiClient";
import { applySessionToken } from "../../utils/authSession";
import styles from "./UpdatePasswordPage.module.css";

export default function UpdatePasswordPage() {
  const navigate = useNavigate();
  const { token } = useParams();
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const submissionInProgressRef = useRef(false);

  // Al menos 12 caracteres, 1 mayúscula, 1 minúscula, 1 número y 1 carácter especial
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^\w\s]).{12,}$/;

  const handleToggleShow = () => {
    setShowPassword(prev => !prev);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (submissionInProgressRef.current) return;

    setErrorMsg("");

    if (!passwordRegex.test(password)) {
      setErrorMsg("La contraseña debe tener al menos 12 caracteres, incluir mayúscula, minúscula, número y carácter especial.");
      return;
    }
    if (password !== confirmPassword) {
      setErrorMsg("Las contraseñas no coinciden.");
      return;
    }

    submissionInProgressRef.current = true;
    setIsSubmitting(true);

    try {
      const { data } = await apiClient.put(`/users/password-reset/${token}`, { password });
      if (!data.token) {
        navigate("/login", { replace: true });
        return;
      }
      applySessionToken(data.token, navigate);
    } catch (error) {
      setErrorMsg(error.response?.data?.message || "Error al actualizar la contraseña.");
      submissionInProgressRef.current = false;
      setIsSubmitting(false);
    }
  };

  return (
    <div className={styles.container}>
      <div className={styles.box}>
        <h2 className={styles.title}>Actualizar Contraseña</h2>
        {errorMsg && <p role="alert" className={styles.error}>{errorMsg}</p>}
        <form onSubmit={handleSubmit} className={styles.form}>
          <div className={styles.field}>
            <label htmlFor="password" className={styles.label}>Nueva Contraseña</label>
            <div className={styles.inputGroup}>
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                placeholder="Ingrese nueva contraseña"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className={styles.input}
                disabled={isSubmitting}
                required
              />
              <button
                type="button"
                onClick={handleToggleShow}
                className={styles.toggleButton}
                disabled={isSubmitting}
              >
                {showPassword ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </div>

          <div className={styles.field}>
            <label htmlFor="confirmPassword" className={styles.label}>Confirmar Contraseña</label>
            <div className={styles.inputGroup}>
              <input
                id="confirmPassword"
                type={showPassword ? "text" : "password"}
                placeholder="Confirme la contraseña"
                value={confirmPassword}
                onChange={e => setConfirmPassword(e.target.value)}
                className={styles.input}
                disabled={isSubmitting}
                required
              />
              <button
                type="button"
                onClick={handleToggleShow}
                className={styles.toggleButton}
                disabled={isSubmitting}
              >
                {showPassword ? "Ocultar" : "Mostrar"}
              </button>
            </div>
          </div>

          <button type="submit" className={styles.submitButton} disabled={isSubmitting}>
            {isSubmitting ? "Actualizando..." : "Actualizar"}
          </button>
        </form>
      </div>
    </div>
  );
}
